import { Capacitor } from '@capacitor/core';

export const isNative = () => {
    return Capacitor.getPlatform() !== 'web';
};

export const getPlatform = () => {
    return Capacitor.getPlatform();
};

export const getPrice = (webPrice) => {
    return webPrice;
};

